import { StyledButtonDelete } from './styles';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { appStatus } from '../../store/modules/app_status/actions';
import { universalService } from '../../services/universalService';

const WarningDeleteModal = ({ text, path, id, width, height, context }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const token = sessionStorage.getItem('Authorization');
  const headers = { Authorization: `Bearer ${token}` };

  const onDelete = async () => {
    try {
      await universalService.deleteItem(path, id, headers);

      Swal.fire({
        title: 'Sucesso!',
        text: 'Deletado com sucesso!',
        icon: 'success',
        confirmButtonText: 'OK'
      });

      if (path === 'projects') {
        dispatch(appStatus('Projetos'));
        navigate('/welcome');
      } else if (path === 'users' && context === 'self') {
        dispatch(appStatus('Usuários'));
        navigate('/welcome');
      } else if (path === 'users' && context === 'admin') {
        sessionStorage.clear();
        navigate('/');
      } else {
        navigate('/welcome');
      }

    } catch (error) {
      console.error('❌ Erro na exclusão:', error);

      const fallbackMessages = {
        users: 'Este usuário não pode ser excluído pois está vinculado a projetos ou áreas.',
        projects: 'Este projeto não pode ser excluído pois está vinculado a outras informações.',
        areas: 'Esta área não pode ser excluída pois está vinculada a projetos ou usuários.',
      };

      const status = error?.response?.status;
      const data = error?.response?.data;

      // Só lê mensagem do backend se for 400 (validação), nunca de um 500
      const backendMessage =
        (status === 400 && typeof data?.[0] === 'string' && data[0]) ||
        (status === 400 && typeof data?.detail === 'string' && data.detail) ||
        fallbackMessages[path] ||
        'Falha ao executar a operação de exclusão. Por favor, tente novamente mais tarde.';

      Swal.fire({
        title: 'Não foi possível excluir',
        text: backendMessage,
        icon: 'error',
        confirmButtonText: 'OK',
      });
    }
  };

  const showDeleteWarning = () => {
    Swal.fire({
      title: 'Confirmação',
      text: 'Tem certeza que deseja deletar?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: 'var(--danger)',
      confirmButtonText: 'Sim, deletar',
      cancelButtonText: 'Não, cancelar',
    }).then((result) => {
      if (result.isConfirmed) {
        onDelete();
      }
    });
  };

  return (
    <>
      <StyledButtonDelete type="button" onClick={showDeleteWarning} width={width} height={height}>
        {text}
      </StyledButtonDelete>
    </>
  );
};

export default WarningDeleteModal;
